/**
 * @mixin
 */
export default {
	props: {
		/**
		 * Sets the variant of the element.
		 * Represents the global variation of the css
		 * @type {String}
		 */
		variant: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			variantClasses: {}
		};
	},
	computed: {
		variantClassList() {
			const classArray = [];

			if (
				this.variantClasses &&
				Object.prototype.hasOwnProperty.call(
					this.variantClasses,
					this.variant
				)
			) {
				let vClassArray = this.variantClasses[this.variant];

				if (!Array.isArray(vClassArray)) {
					//if only a stirng was passed in, convert to an array
					vClassArray = [vClassArray];
				}

				classArray.push(...vClassArray);
			}

			return classArray;
		}
	}
};
